import styles from "@css/modules/Listing.module.scss"

export function PointsAvailability({ listing }) {
    let years = Object.keys(listing.points || {})
    const currentYear = new Date().getFullYear().toString()
    const points = listing.points_on_contract

    return (
        <div className={styles.pointsAvailable}>
            <h2>Point Availability</h2>
            <div className={styles.overItems}>
                {!years.includes(currentYear) && (
                    <div className={styles.item}>
                        <span>
                            {listing.use_month} {currentYear}
                        </span>
                        <div className={styles.points}>{points} Point</div>
                    </div>
                )}
                {years.map((i) => (
                    <div className={styles.item} key={i}>
                        <span>
                            {listing.use_month} {i}
                        </span>
                        <div className={styles.points}>{listing.points[i]} Point</div>
                    </div>
                ))}
            </div>
        </div>
    )
}
